export default __webpack_public_path__ + "static/ecoalliance-community-bb492171e0049f598b7390cb66c19681.png";